import React from 'react';
import './ContextMenu.scss'; 

const ContextMenu = ({ position, onAdd, onEdit, onDelete, onClose }) => {
    if (!position) return null;
    // alert(position.y)
    position.y = Math.max(50, position.y);
    return (
        <div
            className="context-menu"
            style={{
                top: position.y,
                left: position.x + 30,
            }}
        >
            <ul>
                <li onClick={onAdd}>추가</li>
                <li onClick={onEdit}>수정</li>
                <li onClick={onDelete}>삭제</li>
                {/* <li onClick={onClose}>닫기</li> */}
            </ul>
        </div>
    );
};

export default ContextMenu;
